"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 24 24" id=icon-checkmark-24><path fill-rule=evenodd d="M22.68 4.267a1 1 0 0 1 .053 1.413l-13 14a1 1 0 0 1-1.44.027l-7-7a1 1 0 1 1 1.414-1.414l6.266 6.266L21.267 4.32a1 1 0 0 1 1.413-.052Z" clip-rule=evenodd></path></symbol>';
}
